import PosthogService from '~/services/posthog/PosthogService';
import { REDESIGN_SIGNUP_DESIGN_DATE } from '~/services/posthog/events';

export interface IAdditionalOfficeInfoSubmittedPayload {
  /** Total professionals within the configured radius of the office.
   *  Omit when the count query hasn't resolved (loading or error) to keep the
   *  funnel from being skewed by a default 0. */
  professionalCount?: number;
}

/**
 * Fires when the user submits the Office Setup step (Step 3).
 * Event: dental_portal:office_signup:additional_office_info_submitted
 */
export function fireAdditionalOfficeInfoSubmitted(
  payload: IAdditionalOfficeInfoSubmittedPayload = {},
): void {
  PosthogService.getInstance().track(
    'dental_portal:office_signup:additional_office_info_submitted',
    {
      design_date: REDESIGN_SIGNUP_DESIGN_DATE,
      ...(payload.professionalCount !== undefined && {
        professional_count: payload.professionalCount,
      }),
    },
  );
}
